import React from 'react';

import UserFeedback from 'components/UserFeedback';
import ZendeskChat from 'components/ZendeskChat';
import { publicRuntimeConfig } from 'config';
import { useIsEditing } from 'hooks';

export default function FloatingButtons() {
	const isEditing = useIsEditing();
	const zendeskKey =
		publicRuntimeConfig?.NEXT_PUBLIC_CUSTOMER_SERVICE_ZENDESK_CHAT_ID;
	if (isEditing) {
		return null;
	}
	return (
		<div className="fixed bottom-4 right-4 z-chatButton flex gap-x-2">
			<UserFeedback />
			{zendeskKey && <ZendeskChat zendeskKey={zendeskKey} />}
		</div>
	);
}
FloatingButtons.displayName = 'FloatingButtons';
